// Imports
import axios from 'axios';

// Export actions
/**
 * Get a list of Saved Pricing.
 * @param {Object} { token: string, query: string, direction: string, order: string, limit: number, page: number}
 * @return {AxiosPromise} Http request
 */
export const getSavedPricing = ({ token, id, query, direction, order, limit, page }) => {
  const params = {
    q: query || null,
    direction,
    order,
    limit,
    page,
  };

  let urlString = '';

  Object.keys(params).map(i => {
    urlString += params[i] ? `&${i}=${params[i]}` : '';
    return i;
  });

  urlString = urlString.length > 0 ? `?${urlString.slice(1)}` : '';

  return axios({
    method: 'get',
    url: `${window.API_URL}/savedpricing/${id}${urlString}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Get a specific Customer.
 * @param {Object} { token: string, id: number}
 * @return {AxiosPromise} Http request
 */
export const readSavedPricing = ({ token, id }) => {
  return axios({
    method: 'get',
    url: `${window.API_URL}/savedpricing/${id}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Update a Saved Pricing.
 * @param {Object} { token: string, payload: { } }
 * @return {AxiosPromise} Http request
 */
export const updateSavedPricing = ({ token, id, payload }) =>
  axios({
    method: 'put',
    url: `${window.API_URL}/savedpricing/${id}`,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });

/**
 * Update a Saved Pricing.
 * @param {Object} { token: string, payload: { } }
 * @return {AxiosPromise} Http request
 */
export const updateAllSavedPricing = ({ token, payload }) =>
  axios({
    method: 'post',
    url: `${window.API_URL}/savedpricing/updateall`,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });
